import {ref} from "vue";
import _ from "lodash";

const useOrderBy = (initialOrderBy, initialOrderDir = 'desc') => {
  const orderBy = ref(initialOrderBy);

  const orderDirection = ref(initialOrderDir);

  const orderChanged = (newOrderBy) => {
    if (newOrderBy === orderBy.value) {
      orderDirection.value = orderDirection.value === 'asc' ? 'desc' : 'asc';
      return;
    }

    orderBy.value = newOrderBy;
    orderDirection.value = 'desc';
  };

  const orderData = (data) => _.orderBy(data ?? [], orderBy.value, orderDirection.value);

  return {
    orderBy,
    orderDirection,
    orderChanged,
    orderData,
  };
};

export default useOrderBy;